import {
  Button,
  Input,
  Label,
  TextField,
  TextFieldProps,
} from "react-aria-components";
import { FieldError, FieldErrors, useFormContext } from "react-hook-form";

interface InputFieldProps extends Omit<TextFieldProps, "onChange"> {
  label?: string;
  description?: string;
  name: string;
  fieldId?: string;
  message?: string;
  isDisabled?: any;
  isRequired?: boolean;
  errorText?: string;
  customStyle?: string;
  visible?: boolean;
  showIcon?: boolean;
  showPhoneIcon?: boolean;
  handleChange?: () => void;
  labelLeft?: boolean;
  placeholder?: string;
  register?: any;
}

export default function TextInput({
  label,
  description,
  name,
  fieldId,
  message,
  isDisabled,
  isRequired = false,
  errorText,
  customStyle = "",
  visible = false,
  showIcon = false,
  showPhoneIcon = false,
  handleChange,
  labelLeft = false,
  placeholder = " ",
  register,
  ...props
}: InputFieldProps) {
  const leftLabelCss = labelLeft ? "flex gap-4 w-full items-start" : "";

  const {
    setValue,
    getValues,
    clearErrors,
    formState: { errors },
  } = useFormContext();

  const filedName = name || "";
  const fieldErrors = errors as FieldErrors;

  const errorMessage = fieldErrors[filedName]?.message;
  const errorString =
    typeof errorMessage === "string"
      ? errorMessage
      : errorMessage instanceof Object && "message" in errorMessage
      ? (errorMessage as FieldError).message
      : "";

  const error = errorString || errorText || "";
  const value = getValues(filedName) || "";

  return (
    <TextField
      {...props}
      isInvalid={!!error}
      aria-label={label}
      className={`${leftLabelCss} w-full`}
    >
      <div className={`grid grid-cols-1`}>
        <Label className="text-sm font-medium">{label}</Label>
        <div className="flex items-center bg-[#FBFBFB] border border-[#f0f0f0] rounded-md focus:outline-none overflow-hidden">
          {showPhoneIcon && (
            <div className="flex items-center pl-2">
              <img
                src="/icons/phone.svg"
                alt="phone"
                className="h-[20px] w-[20px] text-gray-500"
              />
            </div>
          )}

          {showPhoneIcon && (
            <Button
              // onPress={onCountryCodeClick}
              className="px-3 py-2 bg-transparent text-gray-700 font-normal text-sm border-r border-gray-300 focus:outline-none"
            >
              +1
            </Button>
          )}
          <Input
            autoComplete="off"
            value={value}
            disabled={isDisabled}
            aria-label={label}
            className={`px-3 block w-full focus:outline-none rounded-full text-sm  bg-[#FBFBFB] h-12  text-gray-900  placeholder:text-gray-400  ${
              isDisabled ? " cursor-not-allowed bg-bg_dark_gray opacity-30" : ""
            } `}
            placeholder={placeholder}
            onChange={(e) => {
              clearErrors(filedName);
              setValue(filedName, e.target.value);
            }}
            id={fieldId}
            {...(register ? register(name) : {})}
          />
          {visible && (
            <Button onPress={handleChange} className="focus:outline-none">
              <img
                src={showIcon ? "/icons/eye.png" : "/icons/eye-slash.svg"}
                alt="visible"
                className="h-5 w-5 focus:outline-none"
              />
            </Button>
          )}
        </div>
        {(error || message) && (
          <div
            className={`bg-transparent flex items-center gap-2 rounded-md mt-2 ${
              message === "Unknown error occurred" ||
              message === "Incorrect password"
                ? "hidden"
                : ""
            }`}
          >
            <img
              src="/icons/error.svg"
              alt="error"
              className="w-[16px] h-[16px]"
            />
            {message && (
              <span className="text-[#DC2626] text-xs leading-[16px] w-full font-normal">
                {message === "Incorrect password"
                  ? "Incorrect password, please try again!"
                  : message}
              </span>
            )}
            {error && (
              <span className="text-[#DC2626] text-xs leading-[16px] font-normal">
                {error}
              </span>
            )}
            {message === "Email already registered" && (
              <div className="w-full text-gray-400 text-[12px] md:text-[12px] font-medium	md:font-medium text-end mb-4 md:my-4 leading-5">
                <a href="/forgot-password" className=" text-[#4589FF] mx-1">
                  Forgot Password?
                </a>
              </div>
            )}
          </div>
        )}
      </div>
    </TextField>
  );
}
